import { render } from "./ProfilKantor.vue?vue&type=template&id=35938a90"
import script from "./ProfilKantor.vue?vue&type=script&lang=js"
export * from "./ProfilKantor.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__